import { useQuery } from "@tanstack/react-query";
import { fetchConfig } from "@/lib/api";

export function useConfig() {
  const { data } = useQuery({ queryKey: ["config"], queryFn: fetchConfig, staleTime: 30_000 });
  return { config: data, isDemo: data ? data.demo : true, vipTestMode: data?.vip_test_mode || "guest" };
}
